<div style="margin-bottom: 2rem;">

  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z1 sagitta-score-accordion score-recap-panel" hideToggle>
      <mat-expansion-panel-header style="height: unset; padding: 24px 24px;">
        <mat-panel-title>

          <div>
            <div *ngIf="amlScore?.overallScore != null" class="flex items-center gap-1" style="margin-bottom: 1rem;">
              <span class="bold" style="text-transform: uppercase;">Rischio:</span>
              <span class="bold">{{amlScore?.overallScore |
                number :
                '1.0-2'}}</span>
              <div [ngClass]="amlScore?.overallEvaluation" style="height: 1.2rem; width: 1.2rem; border-radius: 50%;">
              </div>
              <div>{{(amlScore?.overallEvaluation ? amlScore?.overallEvaluation + '_RISK' : '') | label}}</div>
            </div>


          </div>
        </mat-panel-title>

      </mat-expansion-panel-header>
      <div>


      </div>
    </mat-expansion-panel>

  </mat-accordion>




</div>


<mat-accordion displayMode="flat" [multi]="true" class="sagitta-score-accordion">
  <ng-container *ngFor="let section of amlScore?.sections">
    <mat-expansion-panel hideToggle class="mat-elevation-z0">
      <mat-expansion-panel-header class="primary-border">
        <mat-panel-title>
          <div class="flex justify-between items-center w-full">
            <span>{{section.title}}</span>
            <div class="rounded" style="border: 2px solid; padding: 5px 10px">{{section.sectionScore |
              number : '1.0-2'}}</div>
            <!-- <div class="rounded" style="border: 2px solid; padding: 5px 10px">{{area.contributionToScoreComplessivo |
                number : '1.0-2'}}</div> -->

          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <div class="flex justify-between items-center" style="margin: 1rem 0;">

        </div>
        <div class="rows-container">
          <div class="flex justify-between items-center row">
            <div class="flex-3" style="padding-left: 1rem;">
              <div *ngFor="let element of section.elements; index as j"
                class="flex gap-1 flex-wrap justify-between items-center aml-score-element">
                <div>{{j + 1 + ')'}}</div>
                <div class="flex-3" *ngIf="element.question">{{element.question}}</div>
                <div class="flex-1">
                  {{element.responseId ? element.response : 'N/A'}}
                </div>
                <div style="margin: 0 1rem 0 3rem; width: 60px;" class="flex justify-end">
                  <div class="rounded" style="border: 2px solid; padding: 5px 10px; width: fit-content;">
                    {{element.questionPoints| number : '1.0-2'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="flex justify-end">

      </div>

    </mat-expansion-panel>
  </ng-container>



</mat-accordion>